import type { FabricEditor } from 'modules/fabric-editor';
import React, { createContext, useContext } from 'react';

export const FabricEditorContext = createContext<FabricEditor | null>(null);

export interface FabricEditorProviderProps {
  editor: FabricEditor | null;
  children: React.ReactNode;
}

export const FabricEditorProvider: React.FC<FabricEditorProviderProps> = ({ editor, children }) => {
  return <FabricEditorContext.Provider value={editor}>{children}</FabricEditorContext.Provider>;
};

export function useFabricEditor(): FabricEditor {
  const editor = useContext(FabricEditorContext);
  if (!editor) {
    throw new Error('useFabricEditor must be used inside <FabricEditorProvider>.');
  }
  return editor;
}

export function useFabricEditorOptional(): FabricEditor | null {
  return useContext(FabricEditorContext);
}
